"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var withStyles_1 = require("@material-ui/core/styles/withStyles");
function WithStyles(styles, options) {
    return function (target) {
        return withStyles_1.default(styles, options)(target);
    };
}
exports.WithStyles = WithStyles;
//# sourceMappingURL=withStyles.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@react-form-fields/material-ui/decorators/withStyles.js
// module id = 173
// module chunks = 58